import { render, staticRenderFns } from "./PositionForm.vue?vue&type=template&id=4c23924f&scoped=true"
import script from "./PositionForm.vue?vue&type=script&lang=js"
export * from "./PositionForm.vue?vue&type=script&lang=js"
import style0 from "./PositionForm.vue?vue&type=style&index=0&id=4c23924f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c23924f",
  null
  
)

export default component.exports